import Image from 'app/Components/Shared/Image/image';
import {deleteOrgUser, setShowPopUp, sendLinkToUser} from '../OrgUsersManagementSlice';
import {connect} from 'react-redux';
import React from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import EpiContext from '@episerver/spa-core/Spa';
import {PopUp, ButtonColor} from '../General';
import Config from '../../../../Config';

const GeneralPopUp = ({messageData, setShowPopUp, deleteOrgUser, sendLinkToUser}) => {
  const handleSubmit = async (clickFunc) => {
    if (clickFunc) {
      switch (clickFunc) {
        case 'closePopUp':
          setShowPopUp({show: false});
          break;
        case 'deleteOrgUser':
          setShowPopUp({show: false});
          await deleteOrgUser();
          break;
        case 'openUpdateUserPopup':
          setShowPopUp({show: true, type: PopUp.UpdateUser});
          break;
        case 'sendLinkToUser':
          await sendLinkToUser();
          break;
        default:
          break;
      }
    } else {
      EpiContext.navigateTo(Config.businessLobbyUrl);
      setShowPopUp({show: false});
    }
  };

  return (
    <div className='generalPopUp'>
      <Image src={messageData.icon} />
      <p className='L_title'>{messageData.title}</p>
      {messageData.secondTitle && <p className='M_title'>{messageData.secondTitle}</p>}
      <div className='footerBtn'>
        <BtnSubmit
          className={messageData.buttonColor == ButtonColor.white ? 'white' : ''}
          text={messageData.buttonText}
          onclick={() => handleSubmit(messageData.buttonClick)}
        />
        {messageData.secondButtonText && (
          <BtnSubmit
            className={`${messageData.secondButtonColor == ButtonColor.white ? 'white' : ''}`}
            text={messageData.secondButtonText}
            onclick={() => handleSubmit(messageData.secondButtonClick)}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  messageData: state.orgUsersManagement.messageData,
});

const mapDispatchToProps = {setShowPopUp, deleteOrgUser, sendLinkToUser};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralPopUp);
